module.exports = __webpack_public_path__ + "static/media/circle.9300f69f.svg";